import moment from 'moment'

// REFACTOR-023 (Sprint 14): parse del tacho_timestamp estratto in un helper, così
// può essere calcolato UNA volta in buildVehicleAlerts e riusato dai due check
// (prima ogni funzione lo ri-parsava). Le funzioni esportate restano
// backward-compatible: se `tachigrafo`/`lastDateUtc`/`nowUtc` non sono passati,
// il default param li calcola come prima.
function parseTachoTimestamp(lastpoint) {
    return lastpoint?.telemetry?.tacho_timestamp
        ? moment(parseInt(lastpoint?.telemetry?.tacho_timestamp?.$date?.$numberLong))
        : null
}

export function isNotValidTachoTimestampFromUpdated(
    lastpoint,
    tachigrafo = parseTachoTimestamp(lastpoint)
) {
    const updated_at = moment(lastpoint?.updated_at)

    if (tachigrafo && updated_at.diff(tachigrafo, 'minutes') >= 10) return true

    return false
}

export function isNotValidTachoTimestampFromDevice(
    lastpoint,
    tachigrafo = parseTachoTimestamp(lastpoint)
) {
    const centralina = lastpoint?.telemetry?.device_timestamp
        ? moment(lastpoint?.telemetry?.device_timestamp).utc(true)
        : null

    if (centralina && centralina.diff(tachigrafo, 'minutes') >= 10) return true

    return false
}

export function returnToTheFuture(
    lastpoint,
    lastDateUtc = moment(lastpoint?.date).utc(true),
    nowUtc = moment().utc(true)
) {
    if (lastDateUtc.diff(nowUtc, 'hours') >= 1) return true
    return false
}

// REFACTOR-023 (Sprint 14): `now` accettato come parametro così il chiamante batch
// (getter getTrucksWithAlerts, ×660 a ogni polling) lo alloca UNA sola volta invece
// che per ogni veicolo. Default = moment() → chiamanti esistenti invariati. La
// semantica degli alert è identica: stessi rami, stesse soglie; cambiano solo le
// allocazioni di moment() condivise/deduplicate (timestamp tacho parsato una volta,
// `last_date` riusato per returnToTheFuture).
export function buildVehicleAlerts(vehicle, now = moment()) {
    let alerts = {}

    const lastpoint = vehicle?.lastpoint
    let truckSpeed = lastpoint?.tacho_speed || lastpoint?.speed
    const last_date = moment(lastpoint?.date).utc(true)
    const nowUtc = now.clone().utc(true)
    const tachigrafo = parseTachoTimestamp(lastpoint)

    if (
        lastpoint?.telemetry?.battery_level !== undefined &&
        lastpoint?.telemetry?.battery_level <= 20
    ) {
        let icon =
            lastpoint?.telemetry?.battery_level <= 5
                ? 'fa-solid fa-battery-slash'
                : 'fa-solid fa-battery-low'
        alerts.low_battery_level = { icon: icon, problem: 'low_battery_level', unicode: '&#xF244;' }
    }
    if (lastpoint?.driver && lastpoint?.driver.id == 1 && truckSpeed && vehicle.type != 3) {
        alerts.no_card = {
            icon: 'fak fa-user-nocard',
            problem: 'no_card_driving',
            unicode: '&#xF2C2;'
        }
    }
    if (
        lastpoint?.telemetry?.tacho_overspeed &&
        lastpoint?.telemetry?.tacho_overspeed == 1 &&
        truckSpeed
    ) {
        alerts.tacho_overspeed = {
            icon: 'fa-solid fa-gauge-max',
            problem: 'tacho_overspeed',
            unicode: '&#xF4F5;'
        }
    }

    if (lastpoint?.telemetry?.external_voltage !== undefined) {
        if (lastpoint.telemetry.external_voltage == 0) {
            alerts.no_power_supply = {
                icon: 'fa-solid fa-plug-circle-xmark',
                problem: 'no_power_supply',
                unicode: '&#xF244;'
            }
        } else if (lastpoint.telemetry.external_voltage < 9000) {
            alerts.no_power_supply = {
                icon: 'fa-solid fa-plug-circle-exclamation',
                problem: 'low_power_supply',
                unicode: '&#xF244;'
            }
        }
    }
    if (lastpoint?.telemetry?.gnss_status && lastpoint?.telemetry?.gnss_status == 1) {
        alerts.no_gps = {
            icon: 'fa-solid fa-signal-bars-slash',
            problem: 'no_gps',
            unicode: '&#xF7C5;'
        }
    }
    if (isNotValidTachoTimestampFromUpdated(lastpoint, tachigrafo)) {
        alerts.tacho_clock_from_updated_error = {
            icon: 'fa-solid fa-reply-clock',
            problem: 'tacho_clock_from_updated_error',
            unicode: '&#xE33E;'
        }
    }
    if (isNotValidTachoTimestampFromDevice(lastpoint, tachigrafo)) {
        alerts.tacho_clock_from_device_error = {
            icon: 'fa-solid fa-truck-clock',
            problem: 'tacho_clock_from_device_error',
            unicode: '&#xE33E;'
        }
    }
    if (returnToTheFuture(lastpoint, last_date, nowUtc)) {
        alerts.device_timestamp_error = {
            icon: 'fa-solid fa-calendar-circle-exclamation',
            problem: 'device_timestamp_error',
            unicode: '&#xE46E;'
        }
    }
    if (now.diff(last_date, 'hours') > 24) {
        alerts.no_points = {
            icon: 'fa-solid fa-exclamation-triangle',
            problem: 'no_points',
            unicode: '&#xF071;'
        }
    }

    return alerts
}
